/**
 * 설문조사 API
 */
 import { apiNa } from "@/redworks/api/index";

 const SURVEY_API = "/v1/sv";
 
 function $getCurrentPage(surveyId, params) {
   return apiNa.get(`${SURVEY_API}/${surveyId}/cp`, { params: params });
 }
 function $startSurvey(surveyId, params) {
   return apiNa.put(`${SURVEY_API}/${surveyId}/ssr`,  params);
  }
  
  function $submitSurvey(surveyId, params) {
    return apiNa.put(`${SURVEY_API}/${surveyId}/esr`,  params);
  }
  
  function $createQuestionAsnwer(surveyId, params) {
    return apiNa.post(`${SURVEY_API}/${surveyId}/qa`,  params);
  }

  function $moveToPreviousPage(surveyId, params) {
    return apiNa.put(`${SURVEY_API}/${surveyId}/previous`, params);
  }

  function $getCurrentPreviewPage(surveyId, params) {
    return apiNa.get(`${SURVEY_API}/${surveyId}/cpp`, { params: params });
  }

  function $getSurveyTheme(surveyId) {
    return apiNa.get(`${SURVEY_API}/${surveyId}/theme`);
  }
 
 export { 
    $getCurrentPage,
    $getCurrentPreviewPage,
    $startSurvey,
    $submitSurvey,
    $createQuestionAsnwer,
    $moveToPreviousPage,
    $getSurveyTheme
  };
 